import React from 'react';
import PropTypes from 'prop-types';

const CircleCheckIconNucleo = ({ fill = '#246EFF', stroke = 'white' }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill={fill} />
        <path
            d="M7.375 9.625L9.25 11.5L12.625 8.125"
            stroke={stroke}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

CircleCheckIconNucleo.propTypes = {
    fill: PropTypes.string,
    stroke: PropTypes.string,
};

export default CircleCheckIconNucleo;
